import React, { useEffect } from 'react';
import { Typography, Container, Grid, Box, Link, Paper, Divider } from '@mui/material';
import PropTypes from "prop-types";
import { useLocation } from 'react-router-dom';
import { mapStateToProps } from "../../../redux/reducers";
import { connect } from "react-redux";
import * as actionType from "../../../redux/actionTypes/csaSignup";
import { useState } from 'react';
import CommonLoading from '../../common/components/commonLoading';
import { lang } from 'moment';

const ClientAgreement = (props) => {
  const { state } = useLocation();
  const [docStream, setDocStream]=useState();
  let loginId = props?.userAuth?.user?.id;
  // eslint-disable-next-line no-unused-vars
  const [isLoggin] = useState(loginId ? true : false);
  const [isLoading, setIsLoading] = useState(false);
  const [language, setLanguage] = useState({});



  const agreementID = state?.appId;

  const userRole = props?.userAuth?.user ? props?.userAuth?.user : JSON.parse(sessionStorage.getItem("userData"));

  useEffect(() => {
    setLanguage(props.signupLanguage);
  },[props.signupLanguage])

  useEffect(()=>{
    if (state?.appId) {
      props.getCSADoc(state);
      setIsLoading(true);
    }
  },[state]);

  useEffect(()=>{
    setIsLoading(false);
    if (props.csaSignup?.csaDocument?.csaDocument?.stream) {     
      setDocStream(props.csaSignup?.csaDocument?.csaDocument?.stream);
    }
  },[props.csaSignup?.csaDocument?.csaDocument]);
  
  const generatePDF = () => {
    var link = document.createElement("a");
    link.download = "csa_signup_agreement.pdf";
    link.href = `data:application/pdf;base64,${docStream}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Box sx={{ height: 'auto' }}>
      {isLoading && <CommonLoading />}
      <Container item xs={12} sx={{ padding: '0px', margin: '0px' }}>
        <Paper  sx={{ boxShadow: '1px 4px 8px 1px rgba(0, 0, 0, 0.1)',marginTop: '30px', marginBottom: '100px', padding: '20px',width: '65%', marginLeft: '200px', '@media (max-width: 600px)': { width: '100%', marginLeft: '0px' }}}>   
          <Grid container spacing={2} justifyContent={"center"}>
            <Grid item xs={12}>
              <Typography variant="h2" gutterBottom fontSize={'20px'} letterSpacing={'1px'} marginLeft={'15px'} fontFamily={'texta-bold'} tabIndex={0}>
              {language.csaSignup}
              </Typography>
              <Divider sx={{ alignItems: 'left', borderWidth: 1, backgroundColor: "#006e52", width: '80px', height: '3px', marginLeft: '13px', marginBottom: '20px' }} />
              {/* <Typography variant='p' sx={{ fontSize: '24px', color: "#006e52", textAlign: 'center', display: 'inline', fontFamily: 'Texta-Bold', paddingBottom: "10px", lineHeight: '1.5px', margin: '15px' }}>
                Your CSA Signup Request Form has been submitted to the farm for approval!
              </Typography> */}
              <div style={{ fontSize: '24px', color: "#006e52", fontFamily: 'Texta-Bold', paddingBottom: "10px",margin: '15px' }}>
                <Typography variant='p' component='span'>
                  {language.YourCSASignupRequest}
                </Typography>
              </div>
              <Typography gutterBottom margin={'15px'} fontFamily={'Texta-book'} fontSize={'20px'} >
                {language.Your} <span style={{ fontFamily: 'Texta-bold', fontSize: '20px' }}>{language.AgreementId} {agreementID}</span>
              </Typography>
              <Typography margin={'15px'} fontFamily={'Texta-book'} fontSize={'20px'}>
               {language.YouMay} <button style={{ color: "#006e52",fontWeight:'bold', border:'none', background:'none',textDecoration: 'underline'}} className="cursor-pointer" onClick={generatePDF} tabIndex={0}>{language.download}</button> {language.reference}
              </Typography>

              <Typography variant="body1" gutterBottom margin={'15px'} fontFamily={'Texta-book'} fontSize={'20px'} >
                {language.TheFarmAndDTA}
              </Typography>

            </Grid>
            <Grid item xs={12} margin={'15px'}>
              {userRole.Role === "ADMIN" ? (
              <Link href="/dtahip/admin-dashboard" sx={{ color: "#006e52", textDecorationColor: "#006e52" }}>{language.GoToHomePage}</Link>
              ):(
              <Link href="/dtafinder/csa-landing" sx={{ color: "#006e52", textDecorationColor: "#006e52" }}>{language.GoToHomePage}</Link>
              )}
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

ClientAgreement.propTypes = {
  getCSADoc: PropTypes.func,
  csaSignup: PropTypes.object,
  userAuth: PropTypes.object.isRequired,
  signupLanguage: PropTypes.object,

}

function mapDispatchToProps(dispatch) {
  return {
    getCSADoc: (payload) => dispatch(actionType.getCSADoc(payload)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps) (ClientAgreement);
